import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-placeholder-error',
  templateUrl: './placeholder-error.component.html',
  styleUrls: ['./placeholder-error.component.scss']
})
export class PlaceholderErrorComponent {

}
